import { PUBLIC_PAGE_API_ENDPOINT } from "../constants"

export const getSearchResults = async (query: string, lat: number, lon: number) => {
	if (!query) return

	const headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
		"Accept-Language": "sv",
	}

	const options: RequestInit = {
		headers: headers,
		mode: "cors",
		credentials: "include",
	}
	
	const url = lat && lon ? `${PUBLIC_PAGE_API_ENDPOINT}/api/search?query=${query}&lat=${lat}&lon=${lon}` 
			: `${PUBLIC_PAGE_API_ENDPOINT}/api/search?query=${query}` 
	
	return await fetch(
		url,
		options
	).then((r) => {
		return r.json()
	})
}
export const getAutoSuggestions = async (query: string) => {
	if (!query) return

	const headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
		"Accept-Language": "sv",
	}

	const options: RequestInit = {
		headers: headers,
		mode: "cors",
		credentials: "include",
	}

	return await fetch(
		`${PUBLIC_PAGE_API_ENDPOINT}/api/search/autocomplete?query=${query}`,
		options
	).then((r) => {
		return r.json()
	})
}
